import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EditableListField from './EditableListField';
import './TechnologyAreasSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function ensureArray(arr) {
  return Array.isArray(arr) ? arr : [];
}

function TechnologyAreasSubTab() {
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingArea, setEditingArea] = useState(null);
  const [formData, setFormData] = useState({ name: '', technology_names: [] });

  const fetchAreas = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/technology-areas`);
      setAreas(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAreas();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const technology_names = ensureArray(formData.technology_names);
    try {
      if (editingArea) {
        await axios.put(`${API_URL}/api/technology-areas/${editingArea.id}`, {
          name: formData.name,
          technology_names
        });
      } else {
        await axios.post(`${API_URL}/api/technology-areas`, {
          name: formData.name,
          technology_names
        });
      }
      setShowForm(false);
      setEditingArea(null);
      setFormData({ name: '', technology_names: [] });
      fetchAreas();
      setError(null);
    } catch (err) {
      setError('Ошибка при сохранении: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleEdit = (a) => {
    setEditingArea(a);
    setFormData({
      name: a.name,
      technology_names: ensureArray(a.technology_names)
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить эту область технологий?')) return;
    try {
      await axios.delete(`${API_URL}/api/technology-areas/${id}`);
      fetchAreas();
    } catch (err) {
      setError('Ошибка при удалении: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingArea(null);
    setFormData({ name: '', technology_names: [] });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="technology-areas-sub-tab">
      <div className="tab-header">
        <h2>Области технологий</h2>
        {!showForm && (
          <button className="btn btn-primary" onClick={() => setShowForm(true)}>
            + Добавить область
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <div className="form-container">
          <h3>{editingArea ? 'Редактировать область' : 'Новая область'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="area_name">Название области *</label>
              <input
                type="text"
                id="area_name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                maxLength={255}
                placeholder="Например: Frontend"
              />
            </div>
            <div className="form-group">
              <EditableListField
                label="Названия технологий"
                value={formData.technology_names}
                onChange={(technology_names) => setFormData({ ...formData, technology_names })}
                placeholder="Например: React, Vue"
                addButtonLabel="+ Добавить технологию"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingArea ? 'Сохранить' : 'Создать'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
              <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Технологии</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {areas.length === 0 ? (
              <tr>
                <td colSpan="4" className="empty-state">
                  Нет областей. Добавьте первую.
                </td>
              </tr>
            ) : (
              areas.map((a) => (
                <tr key={a.id}>
                  <td>{a.id}</td>
                  <td>{a.name}</td>
                  <td className="cell-list">
                    {Array.isArray(a.technology_names) && a.technology_names.length > 0
                      ? a.technology_names.map((t, i) => <span key={i} className="list-tag">{t}</span>)
                      : '—'}
                  </td>
                  <td>
                    <button className="btn-icon btn-edit" onClick={() => handleEdit(a)} title="Редактировать">✏️</button>
                    <button className="btn-icon btn-delete" onClick={() => handleDelete(a.id)} title="Удалить">✕</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TechnologyAreasSubTab;
